export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Barcharts.vue?vue&type=template&id=42703668&"


//////////////////
// WEBPACK FOOTER
// ./src/components/paywall/dashboard/Barcharts.vue?vue&type=template&id=42703668&
// module id = 1280
// module chunks = 0